import { createContext, useEffect, useState } from "react";
import { DEVICE_TYPE_MOBILE, DEVICE_TYPE_TABLET, DEVICE_TYPE_WEB } from "../constants/viewports";

export const screenContext = createContext();

export function ScreenContextProvider({ children }) {
  const [currentDevice, setCurrentDevice] = useState(DEVICE_TYPE_WEB);

  if (typeof window !== "undefined") {
    window.onresize = () => {
      window.screen.width > 600
        ? window.screen.width < 768
          ? setCurrentDevice(DEVICE_TYPE_TABLET)
          : setCurrentDevice(DEVICE_TYPE_WEB)
        : setCurrentDevice(DEVICE_TYPE_MOBILE);
    };
  }

  useEffect(() => {
    window.screen.width > 600
      ? window.screen.width < 768
        ? setCurrentDevice(DEVICE_TYPE_TABLET)
        : setCurrentDevice(DEVICE_TYPE_WEB)
      : setCurrentDevice(DEVICE_TYPE_MOBILE);
  }, []);

  return <screenContext.Provider value={{ currentDevice }}>{children}</screenContext.Provider>;
}
